<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    item: Object
  })

  const image = computed(() => {
    if (!props.item.props['teaser-image']) return false
    return {
      'element': props.item.props['teaser-image']['element'],
      'imageUrl': props.item.props['teaser-image']['image-url'],
      'imageAlt': props.item.props['teaser-image']['image-alt']
    }
  })

</script>

<template>
  <a
    :href="item.props.path"
    class="content-teaser"
  >
    <div
      class="content-teaser-image w-full h-80 overflow-hidden"
    >
      <Media
        :media="image"
      />
    </div>
    <div
      class="content-teaser-text text-headline flex flex-row items-center mt-6"
    >
      <Icon
        class="mr-2"
        name="ArrowLink"
      />
      {{ item.props.title }}
    </div>
  </a>
</template>

<style lang="scss" scoped>
  :deep(svg) {
    @apply relative left-0 transition-transform h-4 w-4;
  }

  :deep(svg path) {
    fill: #3D1314 !important;
  }

  :deep(.media-item) {
    @apply w-full h-full object-cover;
  }

  :deep(img) {
    @apply w-full h-full object-cover transition-transform duration-500 ease-out;
  }

  .content-teaser {
    &:hover {
      :deep(img) {
        @apply scale-105;
      }
      :deep(svg) {
        @apply translate-x-1;
      }
    }
  }
</style>
